import { Cliente } from "../cliente/cliente";
import { Zona } from "../zona/zona";

export class Factura {
    n?:string;
    id?:string;
    serie?:string;
    numero?:number;
    feccan?:string;
    fecha?:string;
    moneda?:string;
    tcambio?:string;
    idsucursal?:number;
    idvende?:number;
    guiaremser?:string;
    guiaremnum?:string;
    documen?:string;
    clasepago?:string;
    estado?:string;
    descuadi?:number;
    igv?:number;
    valorvta?:number=0;
    igvt?:number=0;
    total?:number;
    glosa?:string;
    impriglo?:string;
    referencia?:string;
    mercaderia?:string;
    guia?:string;
    apellidos?:string;
    cdoc?:string;
    cserie?:string;
    cnumero?:string;
    diasletras?:string;
    gastosfin?:string;
    fvcto?:string;
    hora?:string;
    valor_brut?:number;
    perc_situa?:string;
    retporcien?:number;
    tot_reten?:number;
    totalfactu?:number;
    pedido?:string;
    despacho?:string;
    doc_pac?:string;
    serie_pac?:string;
    num_pac?:string;
    recibido?:number;
    vuelto?:number;
    direccion?:string;
    basepercep?:string;
    idmatiza?:string;
    efectivo?:number;
    tarjeta?:string;
    tarjetachq?:number;
    voucher?:string;
    banco?:string;
    motivo?:string;
    cfecha?:string;
    tasaint?:string;
    cod_banco?:string;
    autori_maq?:string;
    maq_regis?:string;
    cod_ope?:string;
    operador?:string;
    caja?:string;
    impnogrv?:number=0;
    idfactura?:number;
    idcliente?:string;
    tipo_ope?:string;
    ncorrelativo?:string;
    documencod?:string;
    personalc_id?:string;
    personalm_id?:string;
    dtmodificacion?:string;
    fec_depos?:string;
    turno?:string;
    totaldscto?:number=0;
    tipoopera?:string;
    impinafec?:number=0;
    istc?:number;
    otrostrib?:number;
    cod_nota?:string;
    motivonota?:string;
    ciendscto?:number;
    codleyenda?:string;
    totgratui?:number=0;
    ruc?:string;
    tip_iden?:string;
    mesas?:string;
    respuesta?:string;
    texto?:string;
    comision?:number;
    totalglobal?:number;
    tot_comis?:number;
    saldo?:number;
    dtr_cod_bien:string;
    dtr_mediopago:string;
    dtr_monto:number;
    dtr_porcien:number;
    tot_icbp:number=0;
    fec_entrega?:string;
    entrega?:number;
    link_maps?:number;
    
    cliente?:Cliente;
    constructor(){
        this.cliente = new Cliente();
    }
}
